import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainSection() {
  return <section className="border-y border-brand-line bg-brand-cream px-4 py-5" data-id="element-92" data-mp="38yggibtmasnx">
      <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="2uy5oh5gkn816">
        <h2 className="mb-2 text-center font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-94" data-mp="2ux41q3q70x3m">
          Ti suona familiare?
        </h2>
        <div className="mx-auto mb-3 max-w-3xl space-y-1 text-center text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-95" data-mp="2l8ce27s60yyi">
          <p data-id="element-96" data-mp="2q043ug3hz0nl">
            La domotica ti interessa. Vorresti capire come rendere una casa realmente intelligente.
            Magari hai già guardato video, letto guide o acquistato qualche dispositivo Smart... Ma
            quando arriva il momento di mettere tutto insieme iniziano i dubbi.
          </p>
          <p data-id="element-97" data-mp="22at0qryocu6a">
            Quale sistema scegliere? Quali dispositivi sono compatibili? Serve un hub? Meglio Wi-Fi,
            Zigbee, Thread o Matter? Da dove si comincia? E soprattutto... Come si passa da qualche
            dispositivo collegato a una vera Smart Home organizzata e funzionante?
          </p>
          <p className="font-semibold text-brand-ink" data-id="element-98" data-mp="3nkw00l1ozvk0">
            Se stai iniziando da zero, probabilmente hai già incontrato almeno uno di questi
            problemi.
          </p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-99" data-mp="h94onq3nllf">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm" data-id="element-100" data-mp="38x2mr702x54l">
              <h3 className="mb-1 font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-101" data-mp="3im2ouz9vogn0">
                {point.title}
              </h3>
              {point.lines.map(line => <p key={line} className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-102" data-mp="2q5i693d80n7j">
                  {line}
                </p>)}
            </article>)}
        </div>
      </div>
    </section>;
}